import { ActionBase } from '../actions/action-base';
//
// Library
//
import * as Library from '../../../lib/core/library/index';
//
// Modell
//
import { DealerOption } from '../../../lib/angular/model/dealer/dealer-option';

//
// Actions
//
import {
  DEALER_OPTION_ACTION,
  DealerOptionActionLoad,
  DealerOptionActionSet,
  DealerOptionActionClear,
} from '../actions/dealer-option.action';

//
// Reducer Interface
//
export interface IDealerOption {
  hasItems: boolean;
  items: DealerOption[];
}
//
// Initial State
//
export const DEALER_OPTION_INITIAL_STATE: IDealerOption = {
  hasItems: false,
  items: []
};

/* tslint:disable:no-switch-case-fall-through */
export function DealerOptionReducer(
  state = DEALER_OPTION_INITIAL_STATE,
  action: ActionBase
): IDealerOption {
  //
  // Switch on Action Type
  //
  switch (action.type) {
    case DEALER_OPTION_ACTION.LOAD:
      return _onLoad(state, action as DealerOptionActionLoad);
    case DEALER_OPTION_ACTION.SET:
      return _onSet(state, action as DealerOptionActionSet);
    case DEALER_OPTION_ACTION.CLEAR:
      return _onClear(state, action as DealerOptionActionClear);
    default: {
      return state;
    }
  }
}
//
// General Functions
//
export function LoadDealerOption(state: IDealerOption) {
  return state;
}

//
// _onLoad()
//
function _onLoad(state: IDealerOption, action: DealerOptionActionLoad): IDealerOption {

  return Object.assign({}, state);
}

//
// _onSet()
//
function _onSet(state: IDealerOption, action: DealerOptionActionSet): IDealerOption {
  const _state = Object.assign({}, state, {
    items: action.payload,
    hasItems: Library.isArrayWithLength(action.payload)
  });
  //
  // Do Work...
  //
  return _state;
}

//
// _onClear()
//
function _onClear(state: IDealerOption, action: DealerOptionActionClear): IDealerOption {
  //
  // Do Work...
  //
  return Object.assign({}, state, { items: [] });
}

